import en from './translations/en.json'
import es from './translations/es.json'

export default {
    en, es,
}